/* dcl-pdp-bar.js (Nov 4, 2026)
   Running total for the phone sticky buy bar on the DCL product templates.
   The theme's sticky bar (sections/sticky-atc-bar.liquid) shows only the button
   on a phone. This script adds a label and a total beside it and, when add-ons
   from "Complete your setup" are picked, changes the button to "Add N to cart"
   and adds the product plus the add-ons in one request, the same way the
   in-page add-ons bar does. Phone width only (max-width 767px); the desktop bar
   is untouched. Styles: assets/dcl-pdp-bar.css. If anything is missing the
   script stops and the theme bar works as before. */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');

  function init() {
    var bar = document.querySelector('.sticky-atc-bar');
    var el = bar && bar.querySelector('sticky-atc-bar');
    var form = el && el.querySelector('form');
    var btn = form && form.querySelector('[name="add"]');
    var label = btn && btn.querySelector('span');
    if (!bar || !el || !form || !btn || !label || form.parentNode !== el) return;

    var variants = [];
    try { variants = JSON.parse(bar.querySelector('script[type="application/json"]').textContent) || []; } catch (e) {}
    var titleEl = bar.querySelector('.sticky-atc-bar__product-title');
    var shortTitle = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim().split(' - ')[0] : '';
    var baseText = label.textContent.replace(/\s+/g, ' ').trim() || 'Add to cart';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

    var sum = document.createElement('div');
    sum.className = 'dpdp-sb-sum';
    sum.innerHTML = '<span class="dpdp-sb-l"></span><span class="dpdp-sb-t"></span>';
    el.insertBefore(sum, form);
    var lEl = sum.querySelector('.dpdp-sb-l');
    var tEl = sum.querySelector('.dpdp-sb-t');

    function money(c) {
      return (c / 100).toLocaleString('en-US', { style: 'currency', currency: cur }).replace(/\.00$/, '');
    }
    function picked() {
      return [].slice.call(document.querySelectorAll('[data-dpdp-addons] [data-ao].is-sel'));
    }
    function variant() {
      var s = form.querySelector('[name="id"]');
      var id = s ? Number(s.value) : 0;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return null;
    }
    function qty() {
      var q = form.querySelector('quantity-input input');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }
    function setText(node, t) { if (node.textContent !== t) node.textContent = t; }

    function refresh() {
      var hasPicker = !!form.querySelector('.select:not(.hidden)');
      bar.classList.toggle('dpdp-sb--var', hasPicker);
      if (!mq.matches) { setText(label, baseText); return; }
      var v = variant();
      var ao = picked();
      var n = ao.length;
      var total = v ? v.price * qty() : 0;
      ao.forEach(function (c) { total += parseInt(c.getAttribute('data-price'), 10) || 0; });
      setText(tEl, v ? money(total) : '');
      setText(lEl, n ? shortTitle + ' + ' + n + (n === 1 ? ' add-on' : ' add-ons') : shortTitle);
      if (!btn.disabled) setText(label, n ? 'Add ' + (n + 1) + ' to cart' : baseText);
    }
    function later() { window.setTimeout(refresh, 0); }

    // Add-on picks, variant changes, quantity changes, and the theme resetting the button text.
    var ao = document.querySelector('[data-dpdp-addons]');
    if (ao && window.MutationObserver) {
      new MutationObserver(refresh).observe(ao, { attributes: true, subtree: true, attributeFilter: ['class', 'data-price', 'data-variant'] });
    }
    if (window.MutationObserver) {
      new MutationObserver(refresh).observe(btn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
    ['change', 'input', 'click'].forEach(function (t) { el.addEventListener(t, later); });
    document.addEventListener('change', later);
    try {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, later);
      }
    } catch (e) {}
    if (mq.addEventListener) mq.addEventListener('change', refresh); else if (mq.addListener) mq.addListener(refresh);

    // With add-ons picked on a phone, one request adds the product and the add-ons.
    bar.addEventListener('submit', function (e) {
      if (!mq.matches) return;
      var sel = picked();
      var v = variant();
      if (!sel.length || !v || !v.available) return;
      e.preventDefault();
      e.stopPropagation();
      btn.disabled = true;
      setText(label, 'Adding…');
      var items = [{ id: v.id, quantity: qty() }];
      sel.forEach(function (c) { items.push({ id: parseInt(c.getAttribute('data-variant'), 10), quantity: 1 }); });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw r;
        window.location.href = '/cart';
      }).catch(function () {
        btn.disabled = false;
        setText(label, 'Try again');
      });
    }, true);

    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
